import styles from "./InfoEditModal.module.css";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "antd";
import InputText from "../../../../CommonComponents/InputControls/InputText";
import InputSelect from "../../../../CommonComponents/InputControls/InputSelect";
import useNotification from "../../../../../hooks/useNotification";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import InputEmail from "../../../../CommonComponents/InputControls/InputEmail";
import { ROLE_OPTIONS } from "../../../../../constant";

const InfoEditModal = ({ isOpen, onCancel, onSubmit, data }) => {
  const [loading, setLoading] = useState(true);
  const { showNotification } = useNotification();
  const [initialData, setInitialData] = useState({});
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      setLoading(false);

      const initData = {
        department: data?.department,
        emailAddress: data?.emailAddress,
        role: data?.role,
      };
      setInitialData(initData);
      form.setFieldsValue(initData);
    }
  }, [isOpen]);

  const handleOk = () => {
    onCancel(false);
  };
  const handleCancel = () => {
    onCancel(false);
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);

      const payload = {
        _id: data._id,
        department: values?.department,
        emailAddress: values?.emailAddress,
        role: values?.role,
      };

      const res = await EnterpriseServices.updateMemberById(data?._id, payload);

      if (res) {
        if (res.statusCode === 1) {
          onSubmit();
          onCancel(false);
          showNotification("Member info updated Successfully");
          setLoading(false);
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while updating info", error);
        handleError(error.description);
      } else {
        handleError("Error: Member info is not updated.");
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const handleChange = (key, value) => {
    setInitialData({ ...initialData, [key]: value });
  };

  return (
    <>
      <Modal
        title="Company Information"
        open={isOpen}
        footer={false}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          name="basic"
          form={form}
          layout="vertical"
          style={{ marginTop: 20 }}
          className={styles.form_wrap}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ phoneNumber: "8200989898" }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputText
                placeholder="Enter department"
                label={"Department"}
                name={"department"}
                onChange={handleChange}
                rules={[
                  {
                    required: true,
                    message: "department is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputEmail
                placeholder="Enter email address"
                onChange={handleChange}
                label={"Email"}
                name={"emailAddress"}
                rules={[
                  {
                    required: true,
                    message: "Email Address is required !",
                    whitespace: false,
                  },
                  {
                    type: "email",
                    whitespace: false,
                    message: "Email must be a valid email address !",
                  },
                ]}
              />
            </Col>

            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <InputSelect
                placeholder="Select role"
                label={"Role"}
                name={"role"}
                onChange={handleChange}
                option={ROLE_OPTIONS}
                rules={[
                  {
                    required: true,
                    message: "role is required !",
                    whitespace: false,
                  },
                ]}
              />
            </Col>
          </Row>
          <div className={styles.footer}>
            <Form.Item>
              <Button
                className={styles.submit_btn}
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                Submit
              </Button>
            </Form.Item>
            <Button
              className={styles.cancel_btn}
              type="secondary"
              loading={false}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default InfoEditModal;
